export default "__VITE_ASSET__3f0e119d__"